import { has } from 'ramda';

/**
 * getDeviceType Format
 *
 */

var getDeviceType = function getDeviceType() {
  var userAgent = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)) return 'tablet';
  if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(userAgent)) return 'mobile';
  return 'desktop';
};

/**
 * Currency Format Factory
 * @param { boolean } value - isStrictlyFalse(false) => true
 */

var isStrictlyFalse = function isStrictlyFalse(value) {
  if (!(typeof value === 'boolean')) throw new Error('isStrictlyFalse requires a boolean as a parameter');
  return !value;
};

/**
 * Get Browser - getBrowser() => Browser
 */

var getBrowser = function getBrowser() {
  var userAgent = navigator.userAgent;
  if (userAgent.match(/chrome|chromium|crios/i)) return "chrome";
  if (userAgent.match(/firefox|fxios/i)) return "firefox";
  if (userAgent.match(/safari/i)) return "safari";
  if (userAgent.match(/opr\//i)) return "opera";
  if (userAgent.match(/edg/i)) return "edge";
  return "No browser detection";
};

/**
 * Get Operating system - getOS() => OS
 */

var getOS = function getOS() {
  var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    os = null;
  var macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  if (macosPlatforms.indexOf(platform) !== -1) os = 'Mac OS';else if (iosPlatforms.indexOf(platform) !== -1) os = 'iOS';else if (windowsPlatforms.indexOf(platform) !== -1) os = 'Windows';else if (/Android/.test(userAgent)) os = 'Android';else if (!os && /Linux/.test(platform)) os = 'Linux';
  return os;
};

var EventBus = {
  _eventsList: {},
  subscribeToEvent: function subscribeToEvent(eventName, listener) {
    if (eventName) {
      if (!this._eventsList[eventName]) this._eventsList[eventName] = [];
      if (eventName) this._eventsList[eventName].push(listener);
    }
  },
  emitEvent: function emitEvent(eventName, params) {
    var eventData = this._eventsList[eventName];
    if (eventData) {
      eventData.forEach(function (eventItem) {
        eventItem(params ? params : {});
      });
    }
  },
  unsubscribeToEvent: function unsubscribeToEvent(eventName) {
    if (eventName) delete this._eventsList[eventName];
  }
};

var executeWithChannel = function executeWithChannel(channelName, onChannelExist) {
  if (has(channelName, window)) {
    onChannelExist();
  } else {
    console.warn("Channel  ".concat(channelName, " doesn't exist."));
  }
};
var createEventBusChannel = function createEventBusChannel(channelName) {
  if (!has(channelName, window)) {
    window[channelName] = EventBus;
  }
};
var useEventBusChannel = function useEventBusChannel(channelName) {
  return {
    subscribe: function subscribe(eventName, callback) {
      executeWithChannel(channelName, function () {
        window[channelName].subscribeToEvent(eventName, callback);
      });
    },
    emit: function emit(eventName, payload) {
      executeWithChannel(channelName, function () {
        window[channelName].emitEvent(eventName, payload);
      });
    },
    unsubscribe: function unsubscribe(eventName) {
      executeWithChannel(channelName, function () {
        window[channelName].unsubscribeToEvent(eventName);
      });
    }
  };
};
var EventBusHandler = {
  createEventBusChannel: createEventBusChannel,
  useEventBusChannel: useEventBusChannel
};

export { EventBus, EventBusHandler, getBrowser, getDeviceType, getOS, isStrictlyFalse };
